// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/special-flight-operations-certificate.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/special-flight-operations-certificate/special-flight-operations-certificate.js';

mount([g0]);
